module.exports = function() {
  return new Worker(__webpack_public_path__ + "0f915b9d45e97da606d6.worker.js");
};